module.exports = "/_next/static/images/forgotPasswordIllustration-d1ae2b8f9a61f297004db7afc0755673.svg";